import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowDown } from 'lucide-react';
export function AudienceLadder() {
  const stages = [{
    label: 'Viewer',
    color: 'text-slate-500'
  }, {
    label: 'Follower',
    color: 'text-slate-400'
  }, {
    label: 'Fan',
    color: 'text-slate-300'
  }, {
    label: 'Builder',
    color: 'text-mint-500'
  }];
  return <section className="py-20 lg:py-28 px-6 bg-navy-900 border-y border-slate-800 relative overflow-hidden" data-id="element-44">
      {/* Background gradient accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-mint-500/5 to-transparent" data-id="element-45" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-48">
            <h2 className="text-3xl lg:text-4xl font-bold leading-tight" data-id="element-49">
              Big Follower Counts Don't Convert
            </h2>
          </div>

          {/* Subtext Line 1 */}
          <p className="text-lg text-slate-300 leading-relaxed text-center mb-10" data-id="element-50">
            Brands and sponsors aren’t chasing quantity anymore. They’re paying for quality: real engagement and audiences that act. That same engaged core buy what you drop, show up to events, and power a sustainable creator business.
          </p>

          {/* Ladder Visual - Vertical on mobile, horizontal on md+ */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-2 mb-10" data-id="element-51">
            {stages.map((stage, idx) => <Fragment key={stage.label} data-id="element-52">
                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-navy-950 border border-slate-800 w-full md:w-auto justify-center md:justify-start" data-id="element-53">
                  <div className={`w-2.5 h-2.5 rounded-full ${idx >= 3 ? 'bg-gradient-to-r from-mint-500 to-wave-500' : 'bg-slate-700'}`} data-id="element-54" />
                  <span className={`text-sm font-bold ${stage.color}`} data-id="element-55">
                    {stage.label}
                  </span>
                </motion.div>
                {idx < stages.length - 1 && <>
                    {/* Arrow down on mobile, arrow right on md+ */}
                    <ArrowDown className="w-4 h-4 text-slate-600 flex-shrink-0 md:hidden" data-id="element-56" />
                    <ArrowRight className="w-4 h-4 text-slate-600 flex-shrink-0 hidden md:block" data-id="element-57" />
                  </>}
              </Fragment>)}
          </div>

          {/* Subtext Line 2 */}
          <p className="text-lg text-slate-300 leading-relaxed text-center" data-id="element-58">
            Pulsewave helps you grow your core builders by letting fans
            participate in your process, so they feel invested in your success,
            not just entertained by the output.
          </p>
        </motion.div>
      </div>
    </section>;
}